
// import Footer from '../Footer'

const Layout = ({ children }: any) => {
    return (
        <>
            <div>{children}</div>
            {/* <Footer /> */}
        </>
    )
}

export default Layout